import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import classNames from 'classnames';

import { Link } from 'components/core/Link';

export function PaginationItem({ page = {}, children, selected, disabled, onPageChange }) {
	const handlePageChange = useCallback(() => {
		if (typeof onPageChange === 'function') {
			onPageChange(page);
		}
	}, [onPageChange, page]);
	return (
		<li className={classNames('pagination-item', { selected, disabled })}>
			<Link
				hideBorder
				href={page.link}
				to={page.to}
				rel={page.nofollow ? 'nofollow' : null}
				onClick={handlePageChange}
				className="ph-link"
			>
				{children}
			</Link>
		</li>
	);
}

PaginationItem.propTypes = {
	page: PropTypes.shape({
		link: PropTypes.string,
		to: PropTypes.string,
		nofollow: PropTypes.bool,
	}),
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
	children: PropTypes.node,
	onPageChange: PropTypes.func,
};

export default PaginationItem;
